import React, { forwardRef } from "react";
import { Box as MuiBox, BoxProps as MuiBoxProps } from "@mui/material";

interface ExtraProps {
  show?: boolean;
}

export type BoxProps = MuiBoxProps & ExtraProps;

type BoxComponentProps<C extends React.ElementType> = MuiBoxProps<C> & ExtraProps;

const Box = forwardRef<any, BoxComponentProps<any>>(({ show = true, ...rest }, ref) => {
  return <MuiBox hidden={show === false} ref={ref} {...rest} />;
});

export { Box };
